module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "center aligned",
    staticStyle: {
      "min-width": "140px"
    }
  }, [_c('div', {
    staticClass: "ui checkbox",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "name": "dnt"
    },
    domProps: {
      "indeterminate": _vm.indeterminate,
      "checked": Array.isArray(_vm.value) ? _vm._i(_vm.value, null) > -1 : (_vm.value)
    },
    on: {
      "click": function($event) {
        return _vm.cycleState()
      },
      "change": function($event) {
        var $$a = _vm.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.value = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.value = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label')]), _vm._v(" "), _c('br'), _vm._v(" "), (this.state === 'ignored' || (this.state === 'ignoredUntilFirstSale' && !_vm.automaticallyTrackNewProducts)) ? _c('div', {
    staticClass: "ui tiny label"
  }, [_vm._v("Ignored")]) : (this.state === 'ignoredUntilFirstSale') ? _c('div', {
    staticClass: "ui tiny label"
  }, [_vm._v("Ignored until next order")]) : _c('div', [_vm._v(" ")])]), _vm._v(" "), _c('td', {
    staticClass: "product-settings-image-cell"
  }, [_c('i', {
    class: _vm.product.marketplaceIso31662Code + ' flag'
  }), _vm._v(" "), _c('a', {
    staticClass: "product-settings-image-link",
    attrs: {
      "href": _vm.product.productPage,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "product-settings-row-thumb",
    attrs: {
      "src": _vm.product.imageUrl,
      "alt": _vm.product.productName || ''
    }
  }), _vm._v(" "), _c('br'), _c('small', [_vm._v("[" + _vm._s(_vm.product.asin1) + "]")])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.product.productName) + " "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortName),
      expression: "shortName"
    }],
    staticStyle: {
      "margin-left": "-15px"
    },
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "size": "40"
    },
    domProps: {
      "value": (_vm.shortName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shortName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui tiny left pointing label"
  }, [_vm._v("\n      Short-hand name\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-495ed724!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productsettings/ProductSettingsPage.ProductRow.vue
// module id = 766
// module chunks = 2